import { NavItem } from './general.known.routes';

/**
 * DON'T EVER CHANGE NUMERATION
 */
export enum AdministrationKnownItemId {
  APH_RESOURCE = 1,
  PROVIDERS = 2,
  OTHERS = 3,
  LOCATIONS = 5,
  SUB_LOCATIONS = 6,
  TARIFF_GROUPS = 7,
  USERS = 8,
  CONTRACTS = 9,
  SUB_PARAMETRICS = 10,
  ADMINISTRATION = 11,
  SUPPORT = 12,
  HELP = 13,
  INTEROPERABILITY = 14,
  PAYMENT_RESPONSIBLE = 15,
  ROLES_AND_PERMISSIONS = 17,
  NOTIFICATION = 18,
  ALERT = 19,
  ALERT_NOTIFICATIONS = 20,
  ADMIN_PAGE = 21,
}

const simpleTransformer = (input: NavItem): NavItem & { type: 'sub-parametrics' } => {
  return {
    ...input,
    type: 'sub-parametrics',
  };
};

export const AdministrationKnownRoutes = (k: AdministrationKnownItemId): NavItem => {
  return JSON.parse(JSON.stringify(options[k]));
};
const options: {
  [k in AdministrationKnownItemId]: NavItem & { type: 'sub-parametrics' };
} = {
  [AdministrationKnownItemId.APH_RESOURCE]: simpleTransformer({
    id: AdministrationKnownItemId.APH_RESOURCE,
    displayName: 'Recurso APH',
    iconName: 'ambulance',
    route: '/home/administration/aph-resources',
    parentModule: 'parametrics',
  }),
  [AdministrationKnownItemId.PROVIDERS]: simpleTransformer({
    id: AdministrationKnownItemId.PROVIDERS,
    displayName: 'Prestadores',
    iconName: 'providers',
    route: '/home/administration/providers',
    parentModule: 'parametrics',
  }),
  [AdministrationKnownItemId.OTHERS]: simpleTransformer({
    id: AdministrationKnownItemId.OTHERS,
    displayName: 'Otras Paramétricas',
    iconName: 'agencies',
    route: '/home/administration/other-parametrics',
    parentModule: 'parametrics',
  }),
  [AdministrationKnownItemId.LOCATIONS]: simpleTransformer({
    id: AdministrationKnownItemId.LOCATIONS,
    displayName: 'Localidades',
    iconName: 'location',
    route: '',
  }),
  [AdministrationKnownItemId.SUB_LOCATIONS]: simpleTransformer({
    id: AdministrationKnownItemId.SUB_LOCATIONS,
    displayName: 'Barrios',
    iconName: 'neighborhoods',
    route: '',
  }),
  [AdministrationKnownItemId.TARIFF_GROUPS]: simpleTransformer({
    id: AdministrationKnownItemId.TARIFF_GROUPS,
    displayName: 'Grupos tarifarios',
    iconName: 'tariff-groups',
    route: '',
  }),
  [AdministrationKnownItemId.USERS]: simpleTransformer({
    id: AdministrationKnownItemId.USERS,
    displayName: 'Usuarios',
    iconName: 'user-outline',
    route: '/home/administration/users',
    parentModule: 'parametrics',
  }),
  [AdministrationKnownItemId.CONTRACTS]: simpleTransformer({
    id: AdministrationKnownItemId.CONTRACTS,
    displayName: 'Contratos y Convenios',
    iconName: 'contracts',
    route: '/home/administration/contracts/list',
    parentModule: 'parametrics',
  }),
  [AdministrationKnownItemId.ADMINISTRATION]: simpleTransformer({
    id: AdministrationKnownItemId.ADMINISTRATION,
    displayName: 'Administración',
    iconName: 'parametrics',
    route: '/home/administration/general-admin',
    parentModule: 'parametrics',
  } as NavItem),
  [AdministrationKnownItemId.SUPPORT]: simpleTransformer({} as NavItem),
  [AdministrationKnownItemId.HELP]: simpleTransformer({} as NavItem),
  [AdministrationKnownItemId.SUB_PARAMETRICS]: simpleTransformer({
    id: AdministrationKnownItemId.SUB_PARAMETRICS,
    displayName: 'Administración',
    iconName: 'parametrics',
    route: '/home/administration',
    parentModule: 'parametrics',
  }),
  [AdministrationKnownItemId.INTEROPERABILITY]: simpleTransformer({
    id: AdministrationKnownItemId.INTEROPERABILITY,
    displayName: 'Interoperabilidad',
    iconName: 'sync',
    route: '/home/administration/interoperability',
    parentModule: 'parametrics',
  }),
  [AdministrationKnownItemId.PAYMENT_RESPONSIBLE]: simpleTransformer({
    id: AdministrationKnownItemId.PAYMENT_RESPONSIBLE,
    displayName: 'Directorio de Pagadores',
    tabName: 'DIRECTORIO DE PAGADORES',
    iconName: 'hospital-care',
    route: '/home/administration/payment-responsible',
    parentModule: 'parametrics',
  }),
  [AdministrationKnownItemId.ADMIN_PAGE]: simpleTransformer({
    id: AdministrationKnownItemId.ADMIN_PAGE,
    displayName: 'ADMINISTRACIÓN',
    iconName: 'settings',
    route: '/home/administration/general-admin',
    parentModule: 'parametrics',
  }),
  [AdministrationKnownItemId.ALERT_NOTIFICATIONS]: simpleTransformer({
    id: AdministrationKnownItemId.ALERT_NOTIFICATIONS,
    displayName: 'Alertas y Notificaciones',
    tabName: 'ALERTAS Y NOTIFICACIONES',
    iconName: 'warning-black',
    route: '/home/administration/alert-notifications',
    parentModule: 'parametrics',
  }),
  [AdministrationKnownItemId.ALERT]: simpleTransformer({
    id: AdministrationKnownItemId.ALERT,
    displayName: 'ALERTAS Y NOTIFICACIONES',
    iconName: 'alert',
    route: '/home/administration/alert-notifications',
    parentModule: 'parametrics',
  }),
  [AdministrationKnownItemId.NOTIFICATION]: simpleTransformer({
    id: AdministrationKnownItemId.NOTIFICATION,
    displayName: 'ALERTAS Y NOTIFICACIONES',
    iconName: 'notifications',
    route: '/home/administration/alert-notifications',
    parentModule: 'parametrics',
  }),
  [AdministrationKnownItemId.ROLES_AND_PERMISSIONS]: simpleTransformer({
    id: AdministrationKnownItemId.ROLES_AND_PERMISSIONS,
    displayName: 'Roles y permisos',
    tabName: 'ROLES Y PERMISOS',
    iconName: 'ambulance',
    route: '/home/administration/roles-and-permissions',
    parentModule: 'parametrics',
  }),
};
